// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
  export default {
    white: '#FFFFFF',
    black: '#000000',
    blue: '#007AFF',
    lightGray: '#D3D3D3',
    green:'#34573c',
    violet: '#780073',
    greenWater:'#9fcac0',
    lightViolet:'#f2e6ff',
    magenta:'#c4007a',
    red:"#F44336",
    watergreen:"#cbe1dc"
  };
  